import { AvatarGroup, Stack, Typography } from "@mui/material";
import type { BaseSyntheticEvent, MouseEvent } from "react";
import { useState } from "react";
import ItemsListPopover from "@entrilia/shared/components/ItemsListPopover";
import UserAvatar from "@entrilia/shared/components/UserAvatar";

interface UserAvatarGroupItem {
  userId: string;
  name: string;
}

interface Props {
  users: UserAvatarGroupItem[];
  max?: number;
}

const UsersAvatarGroup = ({ users, max = 2 }: Props) => {
  const [popUpAnchorEl, setPopUpAnchorEl] = useState<HTMLElement | undefined>();

  if (users.length === 0) {
    return null;
  }

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setPopUpAnchorEl((currentAnchorEl) => (currentAnchorEl ? undefined : event.currentTarget));
  };

  const handleClosePopover = (event: BaseSyntheticEvent) => {
    event.stopPropagation();
    setPopUpAnchorEl(undefined);
  };

  return (
    <>
      <AvatarGroup
        max={max}
        onClick={handleClick}
        sx={{ cursor: "pointer", ".MuiAvatar-root": { height: 24, width: 24, fontSize: 12 } }}
      >
        {users.map((user) => (
          <UserAvatar key={user.userId} userName={user.name} size="small" />
        ))}
      </AvatarGroup>
      <ItemsListPopover anchorEl={popUpAnchorEl} onClose={handleClosePopover}>
        <Stack spacing={1} sx={{ px: 1, py: 0.5, maxHeight: 400, overflow: "auto" }}>
          {users.map((user) => (
            <Typography key={user.userId}>{user.name}</Typography>
          ))}
        </Stack>
      </ItemsListPopover>
    </>
  );
};

export default UsersAvatarGroup;
